import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Header from "./Header";
import { AdminSidebar } from "./AdminSidebar";
import AdminHeader from "./AdminHeader";

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    const adminData = localStorage.getItem('adminData');

    if (!token || !adminData) {
      navigate('/admin/login');
    }
  }, [navigate]);

  const isLoginPage = location.pathname === '/admin/login' ||
    location.pathname === '/admin/forget-password';

  if (isLoginPage) {
    return children;
  }

  return (
    <div className="admin-app-wrapper">
      <AdminSidebar />
      {children}
    </div>
  );
};

export default AdminLayout;